//Assembly Strings

export const GENERIC_STRINGS = {
  ITEMS_INCLUDED: 'Items Included',
}

export const ASSEMBLY_STRINGS = {
  ASSEMBLY: 'Assembly',
  PRICE_BUILDER: 'Price Builder',
  ADD_NEW_ASSEMBLY: 'Add New Assembly',
  BUILDER_PRICE: 'Build a Price',
}

export const ACTION_STRINGS = {
  UNDO_CHANGES: "Undo Changes",
  UNDO: "Undo",
  ADD: "Add",
  DELETE: "Delete",
}

export const PART_STRINGS = {
  PART_TEMPLATE: "Part Template",
  CATEGORY: "Category",
}

export const PRICELIST_STRINGS = {
  PRICE_LIST: "Price List",
}

// Part Strings
// Quote Strings
// Invoice Strings
